<template>
  <ion-page style="overflow: auto;">
    <div>
      <fis-header></fis-header>
      <div class="container-fluid" id="itenary-div" style="height: 100% !important;" >
        <div class="row">
          <div class="col-sm-12" id="top-margin"></div>
        </div>
        <br>

        <!-- itenary -->
        <div class="row" id="large-screen">
          <div id="small-screen">
            <div class="row">
              <div class="col-sm-12">
                <div class="modal-search text-center">
                  <button class="btn btn-primary" @click="setOpen(true)">
                    Smart Blog Search
                  </button>
                  <div class="modal fade">
                    <ion-modal id="searchModal" :is-open="isOpen">
                      <ion-header>
                        <ion-toolbar>
                          <ion-button class="btn" fill="clear" slot="start" @click="setOpen(false)">
                            Confirm
                          </ion-button>
                          <ion-button class="btn" fill="clear" @click="setOpen(false)" slot="end">
                            X
                          </ion-button>
                        </ion-toolbar>
                      </ion-header>
                      <ion-content>
                        <div class="dropdown-search">
                          <div class="container mt-3">
                            <div class="row">
                              <auto-complete :page="page" @clicked="loadAutoCompleteSearch"></auto-complete>
                              <div class="text-center mb-4" id="tagline">
                                <p>Easy to find... Simple to use</p>
                              </div>
                              <div class="row mt-5">
                                <label>Country</label>
                                <div class="col-md-9">
                                  <ul>
                                    <li>
                                      <a href="javascript:void(0)"
                                         :class="{ active: isCountrySelected(1) }"
                                         @click="showCountryIntroPanel(1, 'Australia')">Australia</a>
                                    </li>
                                  </ul>
                                </div>
                              </div>
                              <div class="row">
                                <div class="col-md-9">
                                  <label>States</label>
                                  <ul>
                                    <li style="padding: 0px 0px 10px;" v-for="state in states" :key="state.id">
                                      <a href="javascript:void(0)"
                                         :class="{ active: isStateSelected(state.id) }"
                                         @click="showStateIntroPanel(state.id, state.name)">{{ displayStateName(state.name) }}</a>
                                    </li>
                                  </ul>
                                </div>
                              </div>
                            </div>
                            <div class="row mt-2">
                              <label>Regions</label>
                              <div class="col-md-9">
                                <select name="" class="custom-select mb-3" v-model="selectedRegionId" @change="changeRegion"
                                        :disabled="selectedState === '0' || !regions.length || regionsLoading">
                                  <option value="0">Select Region</option>
                                  <option v-for="region in regions" :key="region.id"
                                          :value="String(region.id)">{{ region.name }}
                                  </option>
                                </select>
                              </div>
                            </div>
                            <div class="row mt-2">
                              <label>Shires</label>
                              <div class="col-md-9">
                                <select name="" class="custom-select mb-3" v-model="selectedShireId" @change="changeShire"
                                        :disabled="selectedRegionId === '0' || !shires.length || shiresLoading">
                                  <option value="0">Select Shires</option>
                                  <option v-for="shire in shires" :key="shire.id"
                                          :value="String(shire.id)">{{ shire.name }}
                                  </option>
                                </select>
                              </div>
                            </div>
                            <div class="row mt-2">
                              <label>Towns</label>
                              <div class="col-md-9">
                                <select name="" class="custom-select mb-3" v-model="selectedTownId" @change="changeTown"
                                        :disabled="selectedRegionId === '0' && selectedShireId === '0' || townsLoading">
                                  <option value="0">Select Town</option>
                                  <option v-for="town in towns" :key="town.id"
                                          :value="String(town.id)">{{ town.name }}
                                  </option>
                                </select>
                              </div>
                            </div>
                          </div>
                        </div>
                      </ion-content>
                    </ion-modal>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="col-xl-3" id="search-large" style="margin-top:10px!important;">

            <div class="dropdown-search">
              <div class="container mt-3">
                <form action="">
                  <div class="row">
                    <auto-complete :page=page @clicked="loadAutoCompleteSearch"></auto-complete>
                    <div class="text-center mb-4" id="tagline">
                      <p>Easy to find... Simple to use</p>
                    </div>
                    <div class="row mt-5">
                      <label>Country</label>
                      <div class="col-md-9">
                        <ul>
                          <li>
                            <a href="javascript:void(0)"
                               :class="{ active: isCountrySelected(1) }"
                               @click="showCountryIntroPanel(1, 'Australia')">Australia</a>
                          </li>
                        </ul>

                      </div>
                    </div>
                    <div class="row">
                    <div class="col-md-9">
                      <label>States</label>
                      <ul>
                        <li style="padding: 0px 0px 10px;" v-for="state in states" :key="state.id">
                          <a href="javascript:void(0)"
                             :class="{ active: isStateSelected(state.id) }"
                             @click="showStateIntroPanel(state.id, state.name)">{{ displayStateName(state.name) }}</a>
                        </li>
                      </ul>
                    </div>
                    </div>
                  </div>

                  <div class="row mt-2">
                    <label>Regions</label>
                    <div class="col-md-9">
                      <select name="" class="custom-select mb-3" v-model="selectedRegionId" @change="changeRegion"
                              :disabled="selectedState === '0' || !regions.length || regionsLoading">
                        <option value="0">Select Region</option>
                        <option v-for="region in regions" :key="region.id"
                                :value="String(region.id)">{{ region.name }}
                        </option>
                      </select>
                    </div>
                  </div>

                  <div class="row mt-2">
                    <label>Shires</label>
                    <div class="col-md-9">
                      <select name="" class="custom-select mb-3" v-model="selectedShireId" @change="changeShire"
                              :disabled="selectedRegionId === '0' || !shires.length || shiresLoading">
                        <option value="0">Select Shires</option>
                        <option v-for="shire in shires" :key="shire.id"
                                :value="String(shire.id)">{{ shire.name }}
                        </option>
                      </select>
                    </div>
                  </div>

                  <div class="row mt-2">
                    <label>Towns</label>
                    <div class="col-md-9">
                      <select name="" class="custom-select mb-3" v-model="selectedTownId" @change="changeTown"
                              :disabled="selectedRegionId === '0' && selectedShireId === '0' || townsLoading">
                        <option value="0">Select Town</option>
                        <option v-for="town in towns" :key="town.id"
                                :value="String(town.id)">{{ town.name }}
                        </option>
                      </select>
                    </div>
                  </div>
                </form>

              </div>
            </div>
          </div>
          <div class="col-sm-7 col-md-8 col-lg-8 col-xl-6" id="sm-left-div">
            <div class="container">
              <ion-list v-if="!loaded" style="margin-top: 4%">
                <ion-item v-for="n in 10" :key="n">
                  <ion-thumbnail slot="start">
                    <ion-skeleton-text :animated="true"></ion-skeleton-text>
                  </ion-thumbnail>
                  <ion-label>
                    <h3>
                      <ion-skeleton-text :animated="true" style="width: 80%;"></ion-skeleton-text>
                    </h3>
                    <p>
                      <ion-skeleton-text :animated="true" style="width: 60%;"></ion-skeleton-text>
                    </p>
                    <p>
                      <ion-skeleton-text :animated="true" style="width: 30%;"></ion-skeleton-text>
                    </p>
                  </ion-label>
                </ion-item>
              </ion-list>
              <div class="col-sm-12 col-md-12 col-lg-12 col-xl-12" v-if="loaded">
                <div class="row">
                  <div class="col-sm-9 col-md-7 col-lg-9 col-xl-9" id="sponsors">
                    <h2 style="padding: 1px 20px;">Search Results</h2>
                  </div>
                </div>
                <div class="row" id="business-card" v-for="introPanel in pageIntroPanels" :key="introPanel.id" style="height: 120px!important;" >

                  <div class="col-sm-12 col-md-12 col-lg-12 col-xl-12" id="blog-search-text">
                    <h2 style="text-transform: uppercase"><router-link :to="pageRouteLink(introPanel.link)">
                        {{ introPanel.page_name }}
                    </router-link></h2>
                    <p>To read please click on the heading</p>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <sponsors-page :total-sponsors="6" class="mt-n1"></sponsors-page>
        </div>
      </div>
      <fis-footer></fis-footer>
    </div>

  </ion-page>
</template>

<script lang="ts">
import {defineComponent} from 'vue';
import fisHeader from "@/components/fisHeader.vue";
import fisFooter from "@/components/fisFooter.vue";
import sponsorsPage from "@/components/sponsorsPage.vue";
import {IonPage} from "@ionic/vue";
import {mapGetters, mapActions} from "vuex";
import { displayStateName } from "@/utils/stateDisplayName";
import AutoComplete from "@/components/Autocomplete.vue";
import {IonModal} from "@ionic/vue";
import {IonContent} from "@ionic/vue";
import {IonToolbar} from "@ionic/vue";
import {IonButton} from "@ionic/vue";
import {IonHeader} from "@ionic/vue";


export default defineComponent({
  name: 'smart-blog-search',
  props: {
    page: {
      default: 'blog'
    },
  },
  components: {
    AutoComplete,
    IonModal,
    IonContent,
    IonButton,
    IonToolbar,
    IonHeader,
    IonPage,
    fisHeader,
    fisFooter,
    sponsorsPage
  },
  computed: {
    ...mapGetters({
      getStates: 'states/getStates',
      getRegions: 'regions/getRegions',
      getShires: 'shires/getShires',
      getPages: 'pages/getPages',
      getBlogTowns: 'towns/getBlogTowns',
    }),
  },
  async created() {
    this.selectedCountry = {id: '1', text: 'Australia'}
    this.selectedState = "0"
    this.selectedRegion = "0"
    this.selectedTown = "0"
    this.selectedTownId = "0"
    this.selectedShires = "0"
    await this.initializeFromRoute();
  },
  methods: {
    displayStateName,
    ...mapActions({
        fetchStates: 'states/fetchStates',
        fetchRegions: 'regions/fetchRegions',
        fetchShires: 'shires/fetchShires',
        fetchShiresWithState: "shires/fetchShiresWithState",
        fetchBlogTowns: 'towns/fetchBlogTowns',
        fetchPagesWithCountry: "pages/fetchPagesWithCountry",
        fetchPagesWithState: "pages/fetchPagesWithState",
        fetchPagesWithRegion: "pages/fetchPagesWithRegion",
        fetchPagesWithShire: "pages/fetchPagesWithShire",
        fetchPagesWithTown: "pages/fetchPagesWithTown"
    }),
   async loadAutoCompleteSearch(value) {
      const rawValue = typeof value === 'string' ? value.trim() : '';
      if (!rawValue) {
        await this.reloadPanelsFromFilters();
        return;
      }
      const postCode = rawValue.split('-')[0]?.trim();
      if (!postCode) {
        await this.reloadPanelsFromFilters();
        return;
      }
      this.loaded = false;
      try {
        await this.fetchPagesWithTown(postCode);
        this.pageIntroPanels = this.getPages;
        this.auto = true;
        this.setFilters({name: 'name', id: rawValue}, 'name');
      } catch (e) {
        await this.reloadPanelsFromFilters();
      } finally {
        this.loaded = true;
        this.scrollToTop();
      }
    },
    async reloadPanelsFromFilters() {
      this.loaded = false;
      this.auto = false;
      try {
        if (this.selectedTownId !== "0" && this.selectedTown !== "0") {
          await this.fetchPagesWithTown(this.selectedTown['post_code']);
        } else if (this.selectedShireId !== "0" && this.selectedShires !== "0") {
          await this.fetchPagesWithShire(this.selectedShires['id']);
        } else if (this.selectedRegionId !== "0" && this.selectedRegion !== "0") {
          await this.fetchPagesWithRegion(this.selectedRegion['id']);
        } else if (this.selectedState !== "0") {
          await this.fetchPagesWithState(this.selectedState['id']);
        } else {
          await this.fetchPagesWithCountry(this.selectedCountry['id']);
        }
        this.pageIntroPanels = this.getPages;
      } finally {
        this.loaded = true;
      }
    },
    setFilters($value, $filterName) {
      let index = this.filters.findIndex(function (filter) {
        return filter.name == $filterName
      });
      if (index > -1) {
        this.filters.splice(index, this.filters.length - (index));
      }
      if (typeof ($value.id) !== "undefined") {
        this.filters.push($value)
      }
    },
    scrollToTop() {
      const el = this.$el as HTMLElement;
      el.scrollTo({ top: 0, behavior: 'smooth' });
    },
    setOpen(isOpen: boolean) {
      this.isOpen = isOpen;
    },
    isCountrySelected(countryId) {
      return this.selectedCountry !== "0" && parseInt(this.selectedCountry['id']) === parseInt(countryId);
    },
    isStateSelected(stateId) {
      return this.selectedState !== "0" && parseInt(this.selectedState['id']) === parseInt(stateId);
    },
    async initializeFromRoute() {
      this.loaded = false;
      this.filters = [];
      this.setFilters({name: 'country', id: this.selectedCountry['id']}, 'country');
      await this.showStates();
      let hasRouteMatch = false;
      if (this.$route.query.state) {
        const qState = decodeURIComponent(String(this.$route.query.state));
        const matchedState = this.states.find(
          state => state['name'] === qState || displayStateName(state['name']) === qState
        );
        if (matchedState) {
          this.selectedState = {id: matchedState['id'], text: matchedState['name']};
          this.setFilters({name: 'state', id: this.selectedState['id']}, 'state');
          await this.fetchPagesWithState(this.selectedState['id']);
          this.pageIntroPanels = this.getPages;
          await this.showRegions();
          await this.showStateShires();
          hasRouteMatch = true;
        }
      }
      if (this.$route.query.region && this.selectedState !== "0") {
        const matchedRegion = this.regions.find(region => region['name'] === this.$route.query.region);
        if (matchedRegion) {
          this.selectedRegion = {id: matchedRegion['id'], text: matchedRegion['name']};
          this.selectedRegionId = String(matchedRegion['id']);
          this.setFilters({name: 'region', id: this.selectedRegion['id']}, 'region');
          await this.fetchPagesWithRegion(this.selectedRegion['id']);
          this.pageIntroPanels = this.getPages;
          await this.showShires();
          hasRouteMatch = true;
        }
      }
      if (this.$route.query.shire && this.selectedRegionId !== "0") {
        const matchedShire = this.shires.find(shire => shire['name'] === this.$route.query.shire);
        if (matchedShire) {
          this.selectedShires = {id: matchedShire['id'], text: matchedShire['name']};
          this.selectedShireId = String(matchedShire['id']);
          await this.fetchPagesWithShire(this.selectedShires['id']);
          this.pageIntroPanels = this.getPages;
          hasRouteMatch = true;
        }
      }
      if (!hasRouteMatch) {
        await this.showCountryIntroPanel(this.selectedCountry['id'], this.selectedCountry['text']);
      } else {
        this.loaded = true;
      }
      if (!this.$route.query.country) {
        this.$router.replace({
          path: this.$route.path,
          query: {
            ...this.$route.query,
            country: this.selectedCountry['text']
          }
        });
      }
    },
    pageRouteLink(rawLink: string) {
      const value = decodeURIComponent((rawLink || '').toString()).trim().replace(/^#/, '');
      const slug = value
          .toLowerCase()
          .replace(/[^a-z0-9\s-]/g, '')
          .replace(/\s+/g, '-')
          .replace(/-+/g, '-')
          .replace(/^-|-$/g, '');
      return `/page/${slug || value}`;
    },
    async showCountryIntroPanel(countryId, countryName = 'Australia') {
      this.loaded = false;
      this.selectedCountry = {id: countryId, text: countryName}
      this.selectedState = "0"
      this.selectedRegion = "0"
      this.selectedShires = "0"
      this.selectedRegionId = "0"
      this.selectedShireId = "0"
      this.selectedTown = "0"
      this.selectedTownId = "0"
      await this.showStates();
      this.regions = [];
      this.shires = [];
      this.towns = [];
      this.allRegionTowns = [];
      this.setFilters({name: 'country', id: this.selectedCountry['id']}, 'country');
      this.$router.push({
        path: this.$route.path,
        query: {country: this.selectedCountry['text']}
      })
      await this.fetchPagesWithCountry(countryId);
      this.pageIntroPanels = this.getPages;
      this.loaded = true;
      this.scrollToTop();
    },
    async showStateIntroPanel(stateId, stateName) {
      this.loaded = false;
      this.selectedState =  {id:stateId, text:stateName}
      this.$router.push({
        path: this.$route.path,
        query: {country: this.selectedCountry['text'], state: displayStateName(this.selectedState['text'])}
      })
      await this.fetchPagesWithState(stateId);
      this.pageIntroPanels = this.getPages;
      this.selectedRegion = "0"
      this.selectedRegionId = "0"
      this.selectedTown = "0"
      this.selectedTownId = "0"
      this.selectedShires = "0"
      this.selectedShireId = "0"
      this.towns = [];
      this.allRegionTowns = [];
      await this.showRegions();
      await this.showStateShires();
      this.setFilters({name: 'state', id: this.selectedState['id']}, 'state');
      this.loaded = true;
      this.scrollToTop();
    },
    async changeRegion() {
        if (this.selectedRegionId === "0") {
            this.selectedRegion = "0";
            this.selectedShires = "0";
            this.selectedShireId = "0";
            this.selectedTown = "0";
            this.selectedTownId = "0";
            this.towns = [];
            this.allRegionTowns = [];
            return;
        }
        const matchedRegion = this.regions.find(region => String(region.id) === String(this.selectedRegionId));
        if (!matchedRegion) {
            return;
        }
        this.selectedRegion = {id: matchedRegion.id, text: matchedRegion.name};
        this.loaded = false;
        this.$router.push({
            path: this.$route.path,
            query: {
                country: this.selectedCountry['text'],
                state: displayStateName(this.selectedState['text']),
                region: this.selectedRegion['text']
            }
        })
        await this.fetchPagesWithRegion(this.selectedRegion['id'])
        this.pageIntroPanels = this.getPages;
        this.selectedShires = "0"
        this.selectedShireId = "0"
        this.selectedTown = "0"
        this.selectedTownId = "0"
        await this.showShires();
        await this.loadTowns();
        this.setFilters({name: 'region', id: this.selectedRegion['id']}, 'region');
        this.loaded = true;
        this.scrollToTop();
    },
    async changeShire() {
      if (this.selectedShireId === "0") {
        this.selectedShires = "0";
        this.selectedTown = "0";
        this.selectedTownId = "0";
        this.towns = [...this.allRegionTowns];
        return;
      }
      const matchedShire = this.shires.find(shire => String(shire.id) === String(this.selectedShireId));
      if (!matchedShire) {
        return;
      }
      this.selectedShires = {id: matchedShire.id, text: matchedShire.name};
      this.selectedTown = "0";
      this.selectedTownId = "0";
      this.towns = this.allRegionTowns.filter(town => String(town.shire_id) === String(matchedShire.id));
      this.loaded = false;
      this.$router.push({
            path: this.$route.path,
            query: {
                country: this.selectedCountry['text'],
                state: displayStateName(this.selectedState['text']),
                region: this.selectedRegion['text'],
                shire: this.selectedShires['text']
            }
        })
        await this.fetchPagesWithShire(this.selectedShires['id'])
        this.pageIntroPanels = this.getPages;
      this.loaded = true;
      this.scrollToTop();
    },
    async changeTown() {
      if (this.selectedTownId === "0") {
        this.selectedTown = "0";
        if (this.selectedShireId !== "0" && this.selectedShires !== "0") {
          await this.fetchPagesWithShire(this.selectedShires['id']);
        } else {
          await this.fetchPagesWithRegion(this.selectedRegion['id']);
        }
        this.pageIntroPanels = this.getPages;
        return;
      }
      const matchedTown = this.towns.find(town => String(town.id) === String(this.selectedTownId));
      if (!matchedTown) {
        return;
      }
      this.selectedTown = {id: matchedTown.id, text: matchedTown.name, post_code: matchedTown.post_code};
      this.loaded = false;
      this.$router.push({
        path: this.$route.path,
        query: {
          country: this.selectedCountry['text'],
          state: displayStateName(this.selectedState['text']),
          region: this.selectedRegion['text'],
          ...(this.selectedShireId !== "0" ? {shire: this.selectedShires['text']} : {}),
          town: this.selectedTown['text']
        }
      });
      await this.fetchPagesWithTown(this.selectedTown['post_code']);
      this.pageIntroPanels = this.getPages;
      this.loaded = true;
      this.scrollToTop();
    },
    async loadTowns() {
      this.townsLoading = true;
      await this.fetchBlogTowns(this.selectedRegion['id']);
      this.allRegionTowns = this.getBlogTowns;
      this.towns = [...this.allRegionTowns];
      this.townsLoading = false;
    },
    async showStates() {
      await this.fetchStates(this.selectedCountry['id']);
      this.states = this.getStates;
    },
    async showRegions() {
      this.regionsLoading = true;
      await this.fetchRegions(this.selectedState['id']);
      this.regions = this.getRegions;
      this.regionsLoading = false;
    },
    async showShires() {
      this.shiresLoading = true;
      await this.fetchShires(this.selectedRegion['id']);
      this.shires = this.getShires;
      this.shiresLoading = false;
    },
    async showStateShires() {
      await this.fetchShiresWithState(this.selectedState['id']);
      this.shires = this.getShires;
    }
  },
  data() {
    return {
      isOpen: false,
      filters: [] as Array<any>,
      countries: [],
      categories: [],
      subCategories: [],
      verticals: [] as Array<any>,
      states: [],
      regions: [],
      towns: [] as Array<any>,
      allRegionTowns: [] as Array<any>,
      shires: [],
      selectedTown: {} as any,
      selectedTownId: "0",
      selectedShires: {},
      selectedState: {},
      selectedRegion: {},
      selectedRegionId: "0",
      selectedShireId: "0",
      regionsLoading: false,
      shiresLoading: false,
      townsLoading: false,
      selectedCountry: {},
      selectedCategories: [] as Array<any>,
      selectedSubCategory: {},
      allCategories: [],
      allSubcategories: [],
      loaded: false,
      auto:false,
      pageIntroPanel: '',
      pageIntroPanels: []  as Array<any>
    }
  }
});

</script>

<style scoped>
ion-modal#searchModal {
  --border-radius: 6px;
  --box-shadow: 0 28px 48px rgba(0, 0, 0, 0.4);
}

ion-content {
  --offset-bottom: -15% !important;
}

a.active {
  color: #34aade !important;
  font-weight: 700;
}

#sponsors h2,
#business-card h2 {
  text-decoration: underline;
  text-underline-offset: 0.12em;
}

#blog-search-text h2 a {
  text-decoration: underline;
  text-underline-offset: 0.12em;
}
</style>
